import React, { useEffect, useMemo, useState} from 'react'
import {Row, Col, Form, Card, Button, Divider, Checkbox, Spin, Modal} from 'antd'
import { connect } from 'react-redux'

import InputField from 'components/InputField'
import TextAreaField from 'components/TextArea'
import SelectField from 'components/SelectField'
import FileUpload from 'components/fileUpload'

import {
    SaveIco,
    SaveBlueIco,
    RefreshIco,
    SearchIco,
    MinusSmallIco,
    PlusSmallIco,
    SpinnerIco,
    CheckGreenIco,
    CancelRedIco,
    InputSearchIco,
    ModalCloseIco, SuccessIconLimit, ErrorLimitIcon,
    EroorIco,
} from "../../../../../modules/CustomIcons"


import './index.scss'
import '../../transfer.scss'
import {OWNACCOUNT} from "constants/constants";
import {Account, getAccounts, getSavedDocuments} from "../../../../services/account";
import {SelectOptions} from "../../../../services/form";
import {getCurrentCompany, getUserData} from "../../../../services/user";
import {
    checkAmountForRequest,
    fillCurrentForm,
    fillCurrentFormTemplate,
    financial,
    resetForm
} from "../../../../services/helper";
import AmountField from "components/AmountField";
import NextModal from "components/NextModal";
import {
    BankCodes,
    ClassificationCodes,
    getClassificationCodes,
    getLevelCodes, getTeskilatCodesByFilter
} from "../../../../services/moneytransfer";
import TemplatePopup from "components/TemplatePopup";
import {getCustomerCommission} from "../../../../services/Customers/Commission";
import SaveAsTemplate from "components/SaveAsTemplate";
import {useLocation} from "react-router-dom";
import {setIbanNumber } from "../../../../store/actions/accountStatement";
import { useActions } from 'hooks/useActions'
import { useTranslation } from 'react-i18next'
import {
    benefBankAccCheck,
    checkLimit,
    cutOffService,
    getInfoByAlias,
    IpsNewTransfer,
} from "../../../../services/Transfers/transfers";
import LimitsModal from "components/LimitsModal/LimitsModal";
import {getIpsBdgDocumentNumber} from "../../../../services/Accounts/DocumentNumber";
import FullScreenLoading from "components/FullScreenLoading";
import {deleteFileById} from "../../../../services/Transfers/Files";
import debounce from 'lodash.debounce'



const Dxa: React.FC<any> = ({ ibanNumber,ownProps }) => {
    const {t} = useTranslation()
    const language = localStorage.getItem("i18nextLng")
    const aliasList = [
        {
            label : t("login.mobileNumber"),
            code:'MOBILE',
            value: 1,
        },
        {
            label : 'FİN',
            code:'PIN',
            value: 2,
        },
        {
            label : t("requisites.taxID"),
            code:'TIN',
            value: 3,
        },
        {
            label : 'IBAN',
            code:'IBAN',
            value: 4,
        },
        {
            label : t("requisites.email"),
            code:'email',
            value: 5,
        },
        {
            label : 'Merchant ID',
            code:'MERCHANTID',
            value: 6,
        },
        {
            label : 'Obyektin kodu',
            code:'OBJECTCODE',
            value: 7,
        },
    ];
    const modalDataInitial={
        modalTitle : t('transfers.aniPaySTA'),
        groups: [
            {
                title: false,
                data: []
            }
        ],
        note : "",
        pdfFiles : [],
        buttons : [
            {save : true},
            {sign : true},
            {approve : true},
            {send : true}
        ],
        alertText: "",
    }
    const [visible, setVisible] = useState(false);
    const [aliasStatus, setAliasStatus] = useState(false);
    const [selectedAlias, setSelectedAlias] = useState<any>(null);
    const [inputType, setInputType] = useState('');
    const [inputValue, setInputValue] = useState('');
    const [inputMask, setInputMask] = useState(false);
    const [retryRequest, setRetryRequest]=useState(null);
    const [inputPlaceholder, setInputPlaceholder] = useState('');
    const [inputPrefix, setInputPrefix] = useState<any>(false);
    const [inputMaxLength, setInputMaxLength] = useState<any>(false);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [codeModalVisible, setCodeModalVisible] = useState(false);
    const [allAccounts, setAllAccounts]=useState<Account[]>();
    const [fromSelectOptions, setFromSelectOptions]=useState<SelectOptions[]>();
    const [levelCodeOptions, setLevelCodeOptions]=useState<SelectOptions[]>();
    const [fromBranch, setFromBranch]=useState<Account>();
    const [nextModalVisible, setNextModalVisible] = useState(false);
    const [templatePopupVisible, setTemplatePopupVisible] = useState(false);
    const [saveAsTemplatePopupVisible, setSaveAsTemplatePopupVisible] = useState<boolean>(false);
    const [bankCodes, setBankCodes]=useState<ClassificationCodes>();
    const [allBankCodes, setAllBankCodes]=useState<ClassificationCodes>();
    const [formFields, setFormFields]=useState({});
    const [commissionLoading, setCommissionLoading]=useState(false);
    const [commissionAmount, setCommissionAmount]=useState('');
    const [commissionAmountModal, setCommissionAmountModal]=useState('');
    const [amountModal,setAmountModal] = useState('')
    const [isDisabled,setIsDisabled] = useState(true)
    const [custAcc,setcustAcc] = useState('')
    const [statusLimit,setStatusLimit] = useState('')
    const [documentNo,setDocumentNo] = useState('')
    const [bankTaxId,setBankTaxId] = useState('')
    const [bankCorAcc,setBankCorAcc] = useState('')
    const [bankSwift,setBankSwift] = useState('')
    const [getbyAlias,setGetbyAlias] = useState('N')
    const [limitModal,setlimitModal] = useState(false)
    const [typeTransfer,setTypeTransfer] = useState('')
    const [amountTransfer,setAmountTransfer] = useState('')
    const [cariCount,setCariCount] = useState('')
    const [sendCariCount,setSentCariCount] = useState('')
    const [cariTotalAmount,setCariTotalAmount] = useState('')
    const [limitTotalAmount,setLimitTotalAmount] = useState('')
    const [nextModalNote,setNextModalNote] = useState('')
    const [modalNote,setModalNote] = useState('')
    const [modal2ndtitle,set2ndTitle]= useState('')
    const [currency,setCurrency] = useState('')
    const [alertText,setAlertText] = useState('')
    const [disabledSign,setdisabledSign] = useState(false)
    const [allClassCodes, setAllClassCodes] = useState<any>();
    const [showMessage,setShowMessage] = useState(false)
    const [classCodes, setClassCodes] = useState<ClassificationCodes>();
    const [toBranch, setToBranch] = useState<BankCodes>();
    const [aliaserrorMessage,setAliasError] = useState('')
    const [commCode,setCommCode] = useState('')
    const [ibankRef, setIbankRef] = useState<string>('');
    const [classModalVisible, setClassModalVisible] = useState(false);
    const [message,setMessage]= useState('')
    const [loadinglimit,setLoadingLimit] = useState(false)
    const [accMessage,setAccMessage] = useState(null)
    const [loadingAccount, setLoadingAccount] = useState(false);
    const [getbyTemp,setGetbyTemp] = useState("N")
    const [tempName,setTempName] =useState('')
    const [loadingData, setLoadingData] = useState(false);
    const [selectedAccount, setSelectedAccount] = useState(false);
    const [modalData, setModalData] = useState(modalDataInitial);
    const [disableCode,setDisableCode] = useState(false)
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState([])
        const [fileUp, setFileUp] = useState<any[]>([])

    const location=useLocation();
    const { setIbanNumber } = useActions();
    const addOrEditPage = ownProps?.addOrEditPage || false;
    let messageCutOff = "";
    let alertmessage = ''
    var limitMessage =''

    const modalDataLimit = {
        modalTitle : t('businessCards.limits'),
        note:modalNote,
        type:statusLimit,
        icon:statusLimit==="success"?<SuccessIconLimit/>:<ErrorLimitIcon/>,
        groups : [
            {
                title : false,
                tableHasBorderBottom : true,
                data : [
                    {
                        label : t("transfers.transfersType"),
                        value : typeTransfer
                    },
                    {
                        label : t("transfers.transfersAmount"),
                        value : amountModal
                    },
                    {
                        label : t("transfers.comAmount"),
                        value : commissionAmountModal
                    }
                ]
            },
            {
                title : modal2ndtitle,
                tableHasBorderBottom2 : false,
                tableHasMarginBottom : false,
                data : [
                    {
                        label : t('transfers.transactionsNum'),
                        value : sendCariCount
                    },
                    {
                        label : t('transfers.transactionsTotNum'),
                        value : amountTransfer
                    },
                    {
                        label : t('transfers.allowableToSendNum'),
                        value : cariCount
                    },
                    {
                        label : t('transfers.allowableToSendAmount'),
                        value : cariTotalAmount
                    },
                    {
                        label : t('transfers.totalLimitTransAmount'),
                        value : limitTotalAmount
                    }
                ]
            },

        ],
        pdfFiles : [],
        buttons : [
            {save : true},
            {sign : true},
            {approve : true},
            {send : true}
        ]
    }

    const updateBankCodes = async (modalVisible : boolean = true) => {
        setAccMessage(null)
        setMessage('')

        const typed_code=form.getFieldValue('BENEFACC') || '';
        const typed_name=form.getFieldValue('BENEFBANKNAME_FILTER')?.toString()?.toLowerCase() || '';
        form.setFieldsValue({
            'BENEFNAME': ""
        });
        form.setFieldsValue({
            'BENEFTAXID': ""
        });
        // form.setFieldsValue({
        //     'BENEFBANKCODE': ""
        // });
        setFormFields(old_data => ({
            ...old_data,
            // BENEFBANKCODE: "",
            BENEFNAME: "",
            BENEFTAXID: "",
        }))
        setBankCodes(old_data => { })
        if (typed_code.length >= 3 || typed_name.length >= 3) {
            const data = await getTeskilatCodesByFilter(typed_code, typed_name);

            // setFormFields(old_data => ({
            //     ...old_data,
            //     BENEFBANKCODE: typed_code,
            // }))
            setBankCodes(old_data => data);
        }
        setCodeModalVisible(modalVisible);
    }

    const updateToBankCodeAndName = (row) => {
        setFormFields(old_data => ({
            ...old_data,
            // BENEFBANKCODE : row.code,
            BENEFNAME : row.name,
            BENEFACC : row.orgcode,
            BENEFTAXID: row.taxId,
        }))
        form.setFieldsValue({
            'BENEFACC': row.orgcode,
        });
        form.setFieldsValue({
            'BENEFNAME': row.name,
        });
        form.setFieldsValue({
            'BENEFTAXID': row.taxId,
        });
        setCodeModalVisible(false);
    }

    const updateClassCodes = async (modalVisible: boolean = true) => {
        setAccMessage(null)

        const typed_code = form.getFieldValue('BUDGETCLASSCODE') || '';
        const typed_name = form.getFieldValue('BUDGETCLASSNAME_FILTER')?.toString()?.toLowerCase() || '';


        if(allClassCodes?.filter((data)=>data.code.includes(typed_code)).length === 0){

            setShowMessage(true)

        } else{

            setShowMessage(false)
        }


        if (typed_code.length >= 2 || typed_name.length >= 3) {
            const data = !allClassCodes ? await getClassificationCodes() : allClassCodes;

            setAllClassCodes(old_data => data);

            const filter_codes = data?.filter(row =>
                typed_code && typed_name ? row.code.includes(typed_code) && row.name.toString().toLowerCase().includes(typed_name) :

                    typed_code ? row.code.includes(typed_code) : typed_name ? row.name.toString().toLowerCase().includes(typed_name) : row
            );
            setIsDisabled(false)
            setFormFields(old_data => ({
                ...old_data,
                BUDGETCLASSCODE: typed_code,
            }))

            setClassCodes(old_data => filter_codes);
            setToBranch(old_data => filter_codes[0]);

        }

        setClassModalVisible(modalVisible);
    }

    const updateToClassCodeAndName = (row) => {

        setFormFields(old_data => ({
            ...old_data,
            BUDGETCLASSCODE: row.code

        }))

        setClassModalVisible(false);
    }

    const updateLevelCodes = async () => {
        const data = await getLevelCodes();

        let temp_data=[];

        for (let row of data ){

            // @ts-ignore
            temp_data.push({
                label: `${row.code}-${row.name}`,
                value: row.code
            });
        }

        setLevelCodeOptions(old_data => temp_data);
    }

    const fetchData = async () => {
        setLoadingAccount(true);
        const data = await getAccounts(getCurrentCompany());
        const new_data = data.filter(row=>row.CCY_NAME == "AZN")
        let temp_data=[];

        for (let row of new_data ){
            if(row.STATUS !== "0") {
                if (row.CCY_NAME.toString().toLowerCase() !== 'azn') {
                    continue;
                }
                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.ACCOUNT_NO,
                    extra: `${financial(row.BALANCE_LC)} ${row.CCY_NAME}`
                });

            }
            // @ts-ignore

        }
        setAllAccounts(new_data);
        setFromSelectOptions(old_data => temp_data);

        /**/
        if (location?.state?.trnData){
            
            fillCurrentForm(form, location.state.trnData)
        }
        setIsDisabled(true)
        setLoadingAccount(false);
    };

    useEffect(() => {
        if (location.state?.data)
            loadData()
        else if (location.state?.trnData)
            loadDataTemplate2(location.state)
        else {
            fetchData();
            updateLevelCodes();
            callgetClassificationCodes();
        }

    }, [location.state]);

    const loadData = async () => {
        // setDisableCode(true)
        setLoadingData(true)
        const pdf = await getSavedDocuments(location.state?.data['ibankRef'])
        setFileList(pdf.data?.fileDetailsList)

        // load Account
        setLoadingAccount(true);
        const data = await getAccounts(getCurrentCompany());
        let temp_data = [];
        for (let row of data) {
            if (row.STATUS !== "0") {
                if (row.CCY_NAME.toString().toLowerCase() !== 'azn') {
                    continue;
                }

                // @ts-ignore
                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: `${financial(row.BALANCE_LC)} ${row.CCY_NAME}`
                });
            }
        }
        if(location.state?.edit)
            setIbankRef(location.state?.data['ibankRef'])
        setAllAccounts(data.filter(row => row.STATUS !== "0"));
        setFromSelectOptions(old_data => temp_data);
        setLoadingAccount(false);
        // const pdf = await getSavedDocuments(location.state?.data['ibankRef'])



        // CUSTACC
        const findAccount = data?.find(row => row.IBAN == location.state?.data['CUSTACC']);
        if (findAccount !== undefined) {
            setFromBranch(findAccount);
            setIsDisabled(false)
            if ((form.getFieldValue('PMTID') === "" || form.getFieldValue('PMTID') === undefined) && location.state?.edit === undefined) {
                updateDocumentNumber();
            } else if (location.state?.edit) {
                form.setFieldsValue({
                    'PMTID': location.state?.data['PMTCUSTID']
                });
            }
            form.setFieldsValue({
                'CUSTACC': findAccount.IBAN
            });
        }


            if (location.state?.data['BENEFACC'] !== undefined && location.state?.data['BENEFACC'] !== null) {
                // receiverDetailsbyIban(location.state?.data['BENEFACC'])
                form.setFieldsValue({
                    'BENEFACC':location.state?.data['BENEFACC'],
                    'BENEFNAME':location.state?.data['BENEFNAME'],
                    'BENEFTAXID':location.state?.data['BENEFTAXID'],
                    // 'BENEFBANKCODE':location.state?.data['BENEFBANKCODE'],
                    // 'BENEFBANKNAME':location.state?.data['BENEFBANKNAME'],
                })
            }

        const dataLevelCode = await getLevelCodes();
        let temp_dataDataLevelCode = [];
        for (let row of dataLevelCode) {
            // @ts-ignore
            temp_dataDataLevelCode.push({
                label: `${row.code}-${row.name}`,
                value: row.code
            });
        }
        setLevelCodeOptions(old_data => temp_dataDataLevelCode);
        // callgetClassificationCodes
        const dataClassCodes = await getClassificationCodes();
        setAllClassCodes(old_data => dataClassCodes);
        // BUDGETCLASSCODE
        if (location.state?.data['BUDGETCLASSCODE'] !== undefined && location.state?.data['BUDGETCLASSCODE'] !== null) {
            const filter_codes = dataClassCodes?.filter(row =>
                row.code.includes(location.state?.data['BUDGETCLASSCODE'])
            );
            if (filter_codes?.length > 0) {
                setFormFields(old_data => ({
                    ...old_data,
                    BUDGETCLASSCODE: filter_codes[0].code,
                }))
                setClassCodes(old_data => filter_codes);
                setToBranch(old_data => filter_codes[0]);
            }
        }

        // BUDGETLEVELCODE
        if (location.state?.data['BUDGETLEVELCODE'] !== undefined && location.state?.data['BUDGETLEVELCODE'] !== null) {
            // temp_dataDataLevelCode.find(u => u.value === location.state?.data['BUDGETLEVELCODE'])
            setFormFields(old_data => ({
                ...old_data,
                BUDGETLEVELCODE: location.state?.data['BUDGETLEVELCODE'],
            }))
            form.setFieldsValue({
                'BUDGETLEVELCODE': location.state?.data['BUDGETLEVELCODE']
            });
        }

        // AMOUNT
        form.setFieldsValue({
            'AMOUNT': checkAmountForRequest(Number(location.state?.data['PMTAMOUNT'] !== "NaN" ? location.state?.data['PMTAMOUNT'] : location.state?.data['AMOUNT']))
        });
        // AMOUNT
        form.setFieldsValue({
            'PMTDET': location.state?.data['PMTDET']
        });

        form.setFieldsValue({
            'NOTE': location.state?.data['NOTE']
        });
        // AMOUNT
        form.setFieldsValue({
            'INFOTOBENEF': location.state?.data['INFOTOBENEF']
        });

        setcustAcc(findAccount?.IBAN)

        // COMISSION
        let valueA = checkAmountForRequest(Number(location.state?.data['PMTAMOUNT'] !== "NaN" ? location.state?.data['PMTAMOUNT'] : location.state?.data['AMOUNT']));

        if (!isNaN(valueA)) {
            setCommissionLoading(true);
            setIsDisabled(true)
            console.log("a1");
            
            getCustomerCommission({
                PAYMENT_TYPE: "PT",
                CIF: getCurrentCompany().customerNo,
                CUSTACC: findAccount?.IBAN,
                AMOUNT: valueA,
                CUR: findAccount?.CCY_NAME,
                BENEFBANKCODE: location.state?.data['BENEFBANKCODE'],
                BENEFACC: location.state?.data['BENEFACC'],
                BENEFTAXID: location.state?.data['BENEFTAXID'],
                PMTDET: location.state?.data['PMTDET'],
            }).then(res => {
                setCommissionLoading(false);

                form.setFieldsValue({
                    'COMMAMOUNT': res.COM_AMOUNT ?? ''
                });
                setIsDisabled(false)
                setCommCode(res.CommCode ?? '')
                setCommissionAmount(old_value => res.COM_AMOUNT ?? '')
            })
        } else {
            setCommissionLoading(false);

            form.setFieldsValue({
                'COMMAMOUNT': ''
            });

            setCommissionAmount(old_value => '');
        }
        setLoadingData(false)
    }
    const callgetClassificationCodes = async () => {
        const data = await getClassificationCodes();
        setAllClassCodes(old_data => data);
    }
    const getSelectedFromBranch = async (value:any) => {
        const findAccount=allAccounts?.find(row => row.ACCOUNT_NO==value || row.IBAN === value);

        setIsDisabled(true)
        setFromBranch(findAccount);
        setcustAcc(findAccount?.IBAN)

        if(findAccount !== undefined && findAccount !== null){
            const document_number = await getIpsBdgDocumentNumber(getCurrentCompany());
            form.setFieldsValue({
                'PMTID' : document_number
            });
            setDocumentNo(old_value => document_number)
            setIsDisabled(false)
        }

    }

    useEffect(() => {
        if(ibanNumber.iban && allAccounts){
        const findAccount=allAccounts?.find(row => row.IBAN==ibanNumber.iban);
        setFromBranch(findAccount);

        setIbanNumber({iban: undefined, ccy_name: undefined})
        }

      }, [ibanNumber, allAccounts])
    const updateParentComponentFormData = () => {
        if (ownProps?.getFormElements){
            ownProps?.getFormElements({form});
        }
    }
    const updateDocumentNumber = async () => {
        const document_number = await  getIpsBdgDocumentNumber(getCurrentCompany());

        form.setFieldsValue({
            'PMTID' : document_number
        });
        setDocumentNo(old_value => document_number)
    }
    const loadDataTemplate = async (tempData) => {

        setGetbyTemp('Y')
        setAliasStatus(false)
        setLoadingData(true)
        const docid = documentNo;
        form.resetFields();
        if (tempData?.trnData) {
            fillCurrentFormTemplate(form, tempData?.trnData)
            updateParentComponentFormData();
        }
        if (docid !== "" && docid !== undefined) {
            form.setFieldsValue({
                'PMTCUSTID': docid
            });
            setDocumentNo(old_value => docid)
        }
        // CUSTACC
        const findAccount = allAccounts?.find(row => row.IBAN == tempData?.trnData.CUSTACC);
        if (findAccount !== undefined) {
            updateDocumentNumber()
            setIsDisabled(false)

            setFromBranch(findAccount);
            if (docid === "" || docid === undefined) {
                updateDocumentNumber();
            }
            form.setFieldsValue({
                'CUSTACC': tempData?.trnData.CUSTACC
            });
        }
        // BENEFACC
        if (tempData?.trnData.BENEFACC !== undefined && tempData?.trnData.BENEFACC !== null) {
            const dataBENEFACC = await getTeskilatCodesByFilter(tempData?.trnData.BENEFACC, '');
            if (dataBENEFACC !== undefined && dataBENEFACC.length > 0) {
                setFormFields(old_data => ({
                    ...old_data,
                    BENEFBANKCODE: dataBENEFACC[0].code,
                    BENEFNAME: dataBENEFACC[0].name,
                    BENEFACC: dataBENEFACC[0].orgcode,
                    BENEFTAXID: dataBENEFACC[0].taxId,
                }))

            }
        }
        // BUDGETCLASSCODE
        if (tempData?.trnData.BUDGETCLASSCODE !== undefined && tempData?.trnData.BUDGETCLASSCODE !== null) {
            const dataClassCodes = await getClassificationCodes();
            const filter_codes = dataClassCodes?.filter(row =>
                row.code.includes(tempData?.trnData.BUDGETCLASSCODE)
            );
            if (filter_codes?.length > 0) {
                setFormFields(old_data => ({
                    ...old_data,
                    BUDGETCLASSCODE: filter_codes[0].code,
                }))
                setClassCodes(old_data => filter_codes);
                setToBranch(old_data => filter_codes[0]);
            }
        }

        // BUDGETLEVELCODE
        if (tempData?.trnData.BUDGETLEVELCODE !== undefined && tempData?.trnData.BUDGETLEVELCODE !== null) {
            // temp_dataDataLevelCode.find(u => u.value === location.state?.data['BUDGETLEVELCODE'])
            setFormFields(old_data => ({
                ...old_data,
                BUDGETLEVELCODE: tempData?.trnData.BUDGETLEVELCODE,
            }))
            form.setFieldsValue({
                'BUDGETLEVELCODE': tempData?.trnData.BUDGETLEVELCODE
            });
        }
        // AMOUNT
        form.setFieldsValue({
            'AMOUNT': checkAmountForRequest(Number(tempData?.trnData.AMOUNT !== "NaN" ? tempData?.trnData.AMOUNT : tempData?.trnData.PMTAMOUNT))
        });
        // PMTDET
        form.setFieldsValue({
            'PMTDET': tempData?.trnData.PMTDET.length > 70 ?  tempData?.trnData.PMTDET.substring(0,70) : tempData?.trnData.PMTDET
        });
        form.setFieldsValue({
            'NOTE': tempData?.trnData.NOTE
        });

        form.setFieldsValue({
            'INFOTOBENEF': tempData?.trnData.INFOTOBENEF
        });
        // COMISSION
        let valueA = checkAmountForRequest(Number(tempData?.trnData.AMOUNT !== "NaN" ? tempData?.trnData.AMOUNT : tempData?.trnData.PMTAMOUNT));

        // ALIASTYPE
        if(tempData?.trnData.alias_value){
            setInputType(aliasList[tempData?.trnData.alias_type-1]?.code)
            setSelectedAlias(aliasList[tempData?.trnData.alias_type-1]?.label)
            form.setFieldsValue({
                'alias_type':aliasList[tempData?.trnData.alias_type-1]?.value
            })
            //ALIASVALUE
            form.setFieldsValue({
                'alias_value':tempData?.trnData.alias_value ?? ""
            })
        }

        setTempName(tempData?.templateName)
        setcustAcc(findAccount?.IBAN)
        //ALIASCheck
        // if(tempData?.trnData.alias_value){
        //     getInfoByAlias({
        //         PMTTYPECODE: "PT",
        //         PMTID: tempData?.trnData.PMTID,
        //         CREATEDFROMTEMPL: "Y",
        //         TEMPLATE: {
        //             TEMPLNAME: tempData?.templateName
        //         },
        //         ALIAS: {
        //             ALIASTYPE:aliasList[tempData?.trnData.alias_type-1].code,
        //             ALIASVALUE: aliasList[tempData?.trnData.alias_type-1].code === 'MOBILE'? '+994'+tempData?.trnData.alias_value:tempData?.trnData.alias_value
        //         },
        //         CUSTACC: findAccount?.IBAN
        //     }).then(res=>{
        //         if(res.ALIASRESULT==='Failure'){
        //             setdisabledSign(true)
        //             // setInputDisabled(false)
        //             setAliasError(res.ALIASREMARK)
        //             form.setFieldsValue({
        //                 'alias_value':'',
        //
        //             })
        //             setInputValue('')
        //             setGetbyAlias("N")
        //         }
        //
        //         if(res.ALIASRESULT!=='Failure'){
        //             form.setFieldsValue({
        //                 'BENEFNAME':res.BENEFINFO?.BENEFNAME,
        //                 'BENEFACC': res.BENEFINFO?.BENEFACC,
        //                 'BENEFTAXID':res.BENEFINFO?.BENEFTAXID
        //
        //             })
        //
        //             setBankTaxId(res.BENEFINFO?.BENEFBANKTAXID)
        //             setBankCorAcc(res.BENEFINFO?.BENEFBANKCOREACC)
        //             setBankSwift(res.BENEFINFO?.BENEFBANKSWIFT)
        //
        //             setGetbyAlias('Y')
        //         }
        //         setShowLoading(false)
        //     })
        //     setAliasStatus(true)
        // }
        if (!isNaN(valueA)) {
            setCommissionLoading(true);
            setIsDisabled(true)
            console.log("a2");
            getCustomerCommission({
                PAYMENT_TYPE: "PT",
                CIF: getCurrentCompany().customerNo,
                CUSTACC: findAccount?.IBAN,
                AMOUNT: valueA,
                CUR: findAccount?.CCY_NAME,
                BENEFBANKCODE: tempData?.trnData.BENEFBANKCODE,
                BENEFACC: tempData?.trnData.BENEFACC,
                BENEFTAXID: tempData?.trnData.BENEFTAXID,
                PMTDET: tempData?.trnData.PMTDET.length > 70 ?  tempData?.trnData.PMTDET.substring(0,70) : tempData?.trnData.PMTDET,

            }).then(res => {
                setCommissionLoading(false);

                form.setFieldsValue({
                    'COMMAMOUNT': res.COM_AMOUNT ?? ''
                });
                setCommCode(res.CommCode ?? '')
                setIsDisabled(false)
                setCommissionAmount(old_value => res.COM_AMOUNT ?? '')
            })
        } else {
            setCommissionLoading(false);

            form.setFieldsValue({
                'COMMAMOUNT': ''
            });

            setCommissionAmount(old_value => '');
        }

        // BENEFBANKCODE
        form.setFieldsValue({
            'BENEFBANKCODE': '210005'
        });

        // BENEFBANKNAME
        form.setFieldsValue({
            'BENEFBANKNAME': t("newTransfer.stateTreasuryAgencyDXA")
        });
        setLoadingData(false)


    }

    const loadDataTemplate2 = async (tempData) => {
        setGetbyTemp('Y')
        setLoadingData(true)
        setFileUp(tempData.trnData?.pdf_files);
        // load Account
        setLoadingAccount(true);
        const data = await getAccounts(getCurrentCompany());
        let temp_data = [];
        for (let row of data) {
            if (row.STATUS !== "0") {
                if (row.CCY_NAME.toString().toLowerCase() !== 'azn') {
                    continue;
                }

                // @ts-ignore
                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: `${financial(row.BALANCE_LC)} ${row.CCY_NAME}`
                });
            }
        }
        setAllAccounts(data.filter(row => row.STATUS !== "0"));
        setFromSelectOptions(old_data => temp_data);
        setLoadingAccount(false);

        // updateLevelCode
        const dataLevelCode = await getLevelCodes();
        let temp_dataDataLevelCode = [];
        for (let row of dataLevelCode) {
            // @ts-ignore
            temp_dataDataLevelCode.push({
                label: `${row.code}-${row.name}`,
                value: row.code
            });
        }
        setLevelCodeOptions(old_data => temp_dataDataLevelCode);
        // callgetClassificationCodes
        const dataClassCodes = await getClassificationCodes();
        setAllClassCodes(old_data => dataClassCodes);
        // CUSTACC

        const findAccount = data?.find(row => row.IBAN === tempData?.trnData.CUSTACC || row.ACCOUNT_NO === tempData?.trnData.CUSTACC);
        if (findAccount !== undefined) {
            setFromBranch(findAccount);
            setIsDisabled(false)

            if (form.getFieldValue('PMTID') === "" || form.getFieldValue('PMTID') === undefined) {
                updateDocumentNumber();
            }
            form.setFieldsValue({
                'CUSTACC': findAccount?.IBAN
            });
        }
        setcustAcc(findAccount?.IBAN)
        // BENEFACC

        if (tempData?.trnData.BENEFACC !== undefined && tempData?.trnData.BENEFACC !== null) {
            const dataBENEFACC = await getTeskilatCodesByFilter(tempData?.trnData.BENEFACC, '');
            if (dataBENEFACC !== undefined && dataBENEFACC.length > 0) {
                setFormFields(old_data => ({
                    ...old_data,
                    BENEFBANKCODE: dataBENEFACC[0].code,
                    BENEFACC: dataBENEFACC[0].orgcode,

                }))
                form.setFieldsValue({
                    BENEFACC:dataBENEFACC[0].orgcode
                })
                setSelectedAccount(true);
            }

        }
        // BUDGETCLASSCODE
        if (tempData?.trnData.BUDGETCLASSCODE !== undefined && tempData?.trnData.BUDGETCLASSCODE !== null) {
            const filter_codes = dataClassCodes?.filter(row =>
                row.code.includes(tempData?.trnData.BUDGETCLASSCODE)
            );
            if (filter_codes?.length > 0) {
                setFormFields(old_data => ({
                    ...old_data,
                    BUDGETCLASSCODE: filter_codes[0].code,
                }))
                setClassCodes(old_data => filter_codes);
                setToBranch(old_data => filter_codes[0]);
            }
        }

        // BUDGETLEVELCODE
        if (tempData?.trnData.BUDGETLEVELCODE !== undefined && tempData?.trnData.BUDGETLEVELCODE !== null) {
            // temp_dataDataLevelCode.find(u => u.value === location.state?.data['BUDGETLEVELCODE'])
            setFormFields(old_data => ({
                ...old_data,
                BUDGETLEVELCODE: tempData?.trnData.BUDGETLEVELCODE,
            }))
            form.setFieldsValue({
                'BUDGETLEVELCODE': tempData?.trnData.BUDGETLEVELCODE
            });
        }
// ALIASTYPE


        setTempName(tempData?.templateName)
        setcustAcc(findAccount?.IBAN)
        //ALIASCheck
        // if(tempData?.trnData?.alias_value){
        //     setInputType(aliasList.filter((row)=> row.label ===tempData?.trnData.alias_type)[0].code)
        //     setSelectedAlias(aliasList.filter((row)=> row.label ===tempData?.trnData.alias_type)[0].label)
        //     form.setFieldsValue({
        //         'alias_type':aliasList[tempData?.trnData?.alias_type-1].value
        //     })
        //     //ALIASVALUE
        //     form.setFieldsValue({
        //         'alias_value':tempData?.trnData.alias_type === t("login.mobileNumber") ? '+994'+tempData?.trnData?.alias_value:tempData?.trnData?.alias_value
        //     })
        //     getInfoByAlias({
        //         PMTTYPECODE: "PI",
        //         PMTID: tempData?.trnData?.PMTID,
        //         CREATEDFROMTEMPL: "Y",
        //         TEMPLATE: {
        //             TEMPLNAME: tempData?.templateName
        //         },
        //         ALIAS: {
        //             ALIASTYPE:aliasList.filter((row)=> row.label ===tempData?.trnData.alias_type)[0].code,
        //             ALIASVALUE: tempData?.trnData.alias_type === t("login.mobileNumber") ? '+994'+tempData?.trnData?.alias_value:tempData?.trnData?.alias_value
        //         },
        //         CUSTACC: findAccount?.IBAN
        //     }).then(res=>{
        //         if(res.ALIASRESULT==='Failure'){
        //             setdisabledSign(true)
        //             // setInputDisabled(false)
        //             setAliasError(res.ALIASREMARK)
        //             form.setFieldsValue({
        //                 'alias_value':'',
        //
        //             })
        //             setInputValue('')
        //             setGetbyAlias("N")
        //         }
        //
        //         if(res.ALIASRESULT!=='Failure'){
        //             form.setFieldsValue({
        //                 'BENEFNAME':res.BENEFINFO?.BENEFNAME,
        //                 'BENEFBANKNAME':res.BENEFINFO?.BENEFBANKNAME,
        //                 'BENEFACC': res.BENEFINFO?.BENEFACC,
        //                 'BENEFBANKCODE':res.BENEFINFO?.BENEFBANKCODE,
        //                 'BENEFTAXID':res.BENEFINFO?.BENEFTAXID
        //
        //             })
        //
        //             setBankTaxId(res.BENEFINFO?.BENEFBANKTAXID)
        //             setBankCorAcc(res.BENEFINFO?.BENEFBANKCOREACC)
        //             setBankSwift(res.BENEFINFO?.BENEFBANKSWIFT)
        //
        //             setGetbyAlias('Y')
        //         }
        //         setShowLoading(false)
        //     })
        //     setAliasStatus(true)
        // }
        // AMOUNT
        form.setFieldsValue({
            'AMOUNT': checkAmountForRequest(Number(tempData?.trnData.AMOUNT !== "NaN" ? tempData?.trnData.AMOUNT : tempData?.trnData.PMTAMOUNT))
        });
        // PMTDET
        form.setFieldsValue({
            'PMTDET': tempData?.trnData.PMTDET.length > 70 ?  tempData?.trnData.PMTDET.substring(0,70)?.trim() : tempData?.trnData.PMTDET?.trim()
        });
        form.setFieldsValue({
            'NOTE': tempData?.trnData.NOTE
        });
        // AMOUNT
        form.setFieldsValue({
            'INFOTOBENEF': tempData?.trnData.INFOTOBENEF
        });
        // COMISSION
        let valueA = checkAmountForRequest(Number(tempData?.trnData.AMOUNT !== "NaN" ? tempData?.trnData.AMOUNT : tempData?.trnData.PMTAMOUNT));

        if (!isNaN(valueA)) {
            setCommissionLoading(true);
            setIsDisabled(true)
            console.log("a4");
            const res = await getCustomerCommission({
                PAYMENT_TYPE: "PT",
                CIF: getCurrentCompany().customerNo,
                CUSTACC: findAccount?.IBAN,
                AMOUNT: valueA,
                CUR: findAccount?.CCY_NAME,
                BENEFBANKCODE: tempData?.trnData.BENEFBANKCODE,
                BENEFACC: tempData?.trnData.BENEFACC,
                BENEFTAXID: tempData?.trnData.BENEFTAXID,
                PMTDET: tempData?.trnData.PMTDET.length > 70 ?  tempData?.trnData.PMTDET.substring(0,70) : tempData?.trnData.PMTDET
            })
            if (res !== undefined) {
                setCommissionLoading(false);

                form.setFieldsValue({
                    'CUSTACCFORCOM': res.COM_AMOUNT ?? ''
                });
                setCommCode(res.CommCode ?? '')
                setCommissionAmount(old_value => res.COM_AMOUNT ?? '')
                setIsDisabled(false)
            }
        } else {
            setCommissionLoading(false);

            form.setFieldsValue({
                'CUSTACCFORCOM': ''
            });

            setCommissionAmount(old_value => '');
        }

        // BENEFBANKCODE
        form.setFieldsValue({
            'BENEFBANKCODE': tempData?.trnData?.BENEFBANKCODE
        });

        //BENEFNAME

        form.setFieldsValue({
            'BENEFNAME': tempData?.trnData?.BENEFNAME
        });
        form.setFieldsValue({
            'BENEFTAXID': tempData?.trnData?.BENEFTAXID
        });

        // BENEFBANKNAME
        form.setFieldsValue({
            'BENEFBANKNAME': tempData?.trnData?.BENEFBANKNAME
        });
        updateParentComponentFormData()
        setLoadingData(false)
    }

    const inputHandleChange = (e) => {
        setInputValue(e.target.value)
    }

    const resetFormFields = () => {
        form.resetFields(['BENEFNAME','alias_value','BENEFBANKCODE','BENEFACC', 'BUDGETLEVELCODE'])
        setFormFields(old_data => {});
        setInputValue(old_value => '');
        setInputPlaceholder(old_value => '');
        setAliasStatus(false);
        setStatusLimit('')
        form.resetFields(
            ['PMTID']
        )
        setAccMessage(null)
        setNextModalVisible(false);
        setcustAcc('')
        setRetryRequest(null);
        setCommissionAmount('')
        setFromBranch(undefined)

        // form.resetFields(['showHideEdvBox']);
    }

    const onCloseSuccessModal = () => {
        resetForm(form);
        resetFormFields();
    }

    const updateAlias = (e) => {
        const checked=e.target.checked;
        setAliasError('')
        setAliasStatus(old_value => checked);
        setSelectedAlias(old_value => null)
        setInputPlaceholder(old_value => '')
        setInputValue(old_value => '')
        setInputType('');
        setInputPrefix(false);
        setInputMaxLength(false);
        setShowLoading(false);
        form.setFieldsValue({
            'BENEFNAME':'',
            'BENEFBANKNAME':'',
            'BENEFACC': '',
            'BENEFBANKCODE':'',
            'BENEFTAXID':''

        })
    }

    // const chooseAlisa = (value) => {
    //     setSelectedAlias(old_value => value)
    //     setInputValue(old_value => '');
    //     setInputPrefix(false);
    //     setInputMaxLength(false);
    //     setShowLoading(false);
    //
    //
    //     if (value==1){
    //         setInputType('MOBILE');
    //         setInputMask('11 111_11_11');
    //         setInputPlaceholder('__ ___ __ __');
    //         setInputPrefix('+994');
    //         setInputMaxLength(9)
    //
    //     }else if(value==2){
    //         setInputType('PIN');
    //         setInputMask('#######');
    //         setInputPlaceholder('_______');
    //         setInputMaxLength(7)
    //
    //     }else if(value==3){
    //         setInputType('TIN');
    //         setInputMask('1111111111');
    //         setInputPlaceholder('__________');
    //         setInputMaxLength(10)
    //
    //     }else if(value==4){
    //         setInputType('text');
    //         setInputPlaceholder('');
    //         setInputMaxLength(28);
    //
    //     }else if(value==5){
    //         setInputType('email')
    //         setInputPlaceholder('email@domen.abc');
    //
    //     }else if(value==6){
    //         setInputType('MERCHANTID');
    //         setInputMask('111111111111111111111111111');
    //         setInputPlaceholder('____________________________');
    //
    //     }else if(value==7){
    //         setInputType('OBJECTCODE');
    //         setInputMask('1111111111-11111');
    //         setInputPlaceholder('__________-_____');
    //
    //     }
    //
    // }
    const submitHandler = async (args: any) => {
        let pdf_files = form.getFieldValue('pdf_files') ?? [];
        modalDataInitial.pdfFiles = [];
        console.log("kkk");
        const ans = await calculateCommission(args?.AMOUNT);
        var res = await nextModalApi()

        if(res?.LIMITMSGSTAT === 'Success'){
            await checkBenefAcc()


        }else{
            setlimitModal(true)
        }
            if (pdf_files.length > 0) {

                for (let file of pdf_files) {
                    modalDataInitial.pdfFiles.push({
                        label: file.name,
                        file: file
                    })
                }
            }
            //@ts-ignore
            setModalData((old_data: any) => ({
                ...modalDataInitial,
                groups : [
                    {
                        title : false,
                        tableHasBorderBottom : true,
                        data : [
                            {
                                label : t("transfers.sender"),
                                value : getCurrentCompany()?.name
                            },
                            {
                                label : t("salary.documentNo"),
                                value : form.getFieldValue('PMTID')
                            },
                            {
                                label : t("transfers.fromAccount"),
                                value : custAcc
                            }
                        ]
                    },
                    // {
                    //     title : t("requisites.beneficiary"),
                    //     tableHasBorderBottom2 : true,
                    //     tableHasMarginBottom : true,
                    //     data : [
                    //         {
                    //             label : t("transfers.anipayType"),
                    //             value : aliasList.filter((item)=>item.code===inputType)[0]?.label
                    //         },
                    //         {
                    //             label : t('transfers.identifierANIPAY'),
                    //             value : inputType === 'MOBILE' ? '+994'+form.getFieldValue('alias_value'):form.getFieldValue('alias_value')
                    //         },
                    //     ]
                    // },
                    {
                        title : t("requisites.beneficiary"),
                        tableHasBorderBottom : true,
                        tableHasMarginBottom : true,
                        data : [
                            {
                                label : t("requisites.name"),
                                value : form.getFieldValue('BENEFNAME')
                            },
                            {
                                label : t("deposit.accountNumber"),
                                value : form.getFieldValue('BENEFACC')
                            },
                            {
                                label : t("requisites.taxID"),
                                value : form.getFieldValue('BENEFTAXID')
                            }
                        ]
                    },
                    {
                        title : t("requisites.beneficiaryBank"),
                        tableHasBorderBottom2 : true,
                        tableHasMarginBottom : true,
                        data : [
                            {
                                label : t("requisites.code"),
                                value : form.getFieldValue('BENEFBANKCODE')
                            },
                            {
                                label : t("requisites.name"),
                                value : form.getFieldValue('BENEFBANKNAME')
                            }
                        ]
                    },
                    {
                        title: t("transfers.budgetCodes"),
                        tableHasBorderBottom2 : true,
                        // tableHasMarginBottom: true,
                        data: [
                            {
                                label: t("newTransfer.budgetClassificationCodes"),
                                value: form.getFieldValue("BUDGETCLASSCODE")
                            },
                            {
                                label: t("newTransfer.budgetLevelCode"),
                                value: form.getFieldValue("BUDGETLEVELCODE")
                            }
                        ]
                    },
                    {
                        title : false,
                        data : [
                            {
                                label : t("common.amount"),
                                value : form.getFieldValue('AMOUNT')
                            },
                            {
                                label : t("home.commission"),
                                value : form.getFieldValue('CUSTACCFORCOM')
                            },
                            {
                                label : t("accountStatement.paymentDetails"),
                                value : form.getFieldValue('PMTDET')
                            },
                            {
                                label : t("transfers.infoForBeneficiary"),
                                value : form.getFieldValue('INFOTOBENEF')
                            },
                            {
                                label : t("newTransfer.note"),
                                value : form.getFieldValue('NOTE')

                            }
                        ]
                    }
                ],
                note: messageCutOff,
                alertText: alertmessage,
            }));

    }




    const getFileList = (info : any) => {
        form.setFieldsValue({
            'pdf_files' : info.fileList
        });
    }

    const removeFile = (index:any)=>{
        const myNewFiles = [...fileList]
        myNewFiles.splice(index, 1);
        setFileList(myNewFiles)
    }
const useDebouncedCommission = (calculateCommission: any) => {
  return useMemo(
    () =>
      debounce((value: string) => {
        if (value) {
          calculateCommission({ target: { value } });
        }
      }, 500),
    [calculateCommission]
  );
};
    const calculateCommission = async (e) => {
  setIsDisabled(true);
   let value
        if(e.target !== undefined){
            value = checkAmountForRequest(e.target.value);
        }else{
            value = checkAmountForRequest(e);
        }
  

  if (!isNaN(value)) {
    try {
      setCommissionLoading(true);
      console.log("a3");

      const res = await getCustomerCommission({
        PAYMENT_TYPE: "PT",
        CIF: getCurrentCompany().customerNo,
        CUSTACC: fromBranch?.IBAN,
        AMOUNT: value,
        CUR: fromBranch?.CCY_NAME,
        BENEFBANKCODE: form.getFieldValue("BENEFBANKCODE"),
        BENEFACC: form.getFieldValue("BENEFACC"),
        BENEFTAXID: form.getFieldValue("BENEFTAXID"),
        PMTDET: form.getFieldValue("PMTDET"),
      });
      console.log("aa",res.COM_AMOUNT);
      
      form.setFieldsValue({
        CUSTACCFORCOM: res.COM_AMOUNT,
      });

      setCommCode(res.CommCode);
      setCommissionAmount(res.COM_AMOUNT);
    } catch (error) {
      console.error("Commission error:", error);
      form.setFieldsValue({ CUSTACCFORCOM: "" });
      setCommissionAmount("");
    } finally {
      setCommissionLoading(false);
      setIsDisabled(false);
    }
  } else {
    setCommissionLoading(false);

    form.setFieldsValue({
      CUSTACCFORCOM: "",
    });

    setCommissionAmount("");
    setIsDisabled(false);
  }
};

const debouncedCommission = useDebouncedCommission(calculateCommission);
// console.log("dep",debouncedCommission);

    const openSaveAsTemplateModal = () => {

        setSaveAsTemplatePopupVisible(old_data => false)

        form.validateFields().then(res => {
            setSaveAsTemplatePopupVisible(old_data => true)

        }).catch(err_input_list => {

        })
    }

    const updateDocumentNumberAndCommission = (data) => {
        loadDataTemplate(data)
    }



    // const checkAlias = () => {
    //     setShowLoading(true);
    //     setAliasError('')
    //
    //
    //     getInfoByAlias(
    //         {
    //             PMTTYPECODE: "PT",
    //             PMTID: form.getFieldValue('PMTID'),
    //             CREATEDFROMTEMPL: getbyTemp,
    //             TEMPLATE: {
    //                 TEMPLNAME: tempName
    //             },
    //             ALIAS: {
    //                 ALIASTYPE: inputType,
    //                 ALIASVALUE: inputType === 'MOBILE'? '+994'+form.getFieldValue('alias_value'):form.getFieldValue('alias_value')
    //             },
    //             CUSTACC: custAcc
    //         }
    //     ).then(res =>{
    //         if(res.ALIASRESULT==='Failure'){
    //             setdisabledSign(true)
    //             // setInputDisabled(false)
    //             setAliasError(res.ALIASREMARK)
    //             setGetbyAlias("N")
    //             form.setFieldsValue({
    //                 'alias_value':'',
    //             })
    //
    //             setInputValue('')
    //         }
    //         if(res.ALIASRESULT!=='Failure'){
    //             form.setFieldsValue({
    //                 'BENEFNAME':res.BENEFINFO?.BENEFNAME,
    //                 'BENEFBANKNAME':res.BENEFINFO?.BENEFBANKNAME,
    //                 'BENEFACC': res.BENEFINFO?.BENEFACC,
    //                 'BENEFBANKCODE':res.BENEFINFO?.BENEFBANKCODE,
    //                 'BENEFTAXID':res.BENEFINFO?.BENEFTAXID
    //
    //             })
    //
    //             setBankTaxId(res.BENEFINFO?.BENEFBANKTAXID)
    //             setBankCorAcc(res.BENEFINFO?.BENEFBANKCOREACC)
    //             setBankSwift(res.BENEFINFO?.BENEFBANKSWIFT)
    //
    //             setGetbyAlias('Y')
    //         }
    //         setShowLoading(false)
    //     })
    //
    // }

    const checkLimits = async () => {
        const selected_level = levelCodeOptions.find(row => row.value == form.getFieldValue('BUDGETLEVELCODE'));
        setLoadingLimit(true)
        var res =  await checkLimit(
            {
                PMTTYPECODE: "PT",
                PMTID: form.getFieldValue('PMTID'),
                CREATEDFROMTEMPL: getbyTemp,
                TEMPLATE: {
                    TEMPLNAME: tempName
                },
                GETBYALIAS: getbyAlias,
                ALIAS: {
                    ALIASTYPE: inputType,
                    ALIASVALUE: inputType=== 'MOBILE'?'+994'+form.getFieldValue('alias_value'):form.getFieldValue('alias_value')
                },
                CUSTACC: custAcc,
                CUSTACCAVLBALANCE: fromBranch?.BALANCE,
                CUSTACCFORCOM:  form.getFieldValue('CUSTACCFORCOM'),
                CUSTACCFORCOMCURR: currency,
                BENEFNAME: form.getFieldValue('BENEFNAME'),
                BENEFACC: form.getFieldValue('BENEFACC'),
                BENEFTAXID: form.getFieldValue('BENEFTAXID'),
                BENEFBANKCODE: form.getFieldValue('BENEFBANKCODE'),
                BENEFBANKNAME: form.getFieldValue('BENEFBANKNAME'),
                BENEFBANKTAXID: bankTaxId,
                BENEFBANKCORACC: bankCorAcc,
                BENEFBANKSWIFT: bankSwift,
                PMTAMOUNT: checkAmountForRequest(form.getFieldValue('AMOUNT')),
                COMMAMOUNT: checkAmountForRequest(form.getFieldValue('CUSTACCFORCOM')),
                BUDGETCLASSCODE: form.getFieldValue('BUDGETCLASSCODE'),
                BUDGETCLASSCODENAME: "",
                BUDGETLEVELCODE:  form.getFieldValue('BUDGETLEVELCODE'),
                BUDGETLEVELCODENAME: selected_level ? selected_level.label : '',
                PMTDET: form.getFieldValue('PMTDET'),
                INFOTOBENEF: form.getFieldValue('INFOTOBENEF'),
                NOTE: form.getFieldValue("NOTE")

            },language
        )
            const temp_array=[];
            const labelArray=[]
            if(res?.LIMITMSGSTAT === 'Success'){
                setStatusLimit('success')
            }else if(res?.LIMITMSGSTAT === 'Failure'){
                setStatusLimit('failure')
                setdisabledSign(true)
            }else if (res?.LIMITMSGSTAT === 'Success' && res?.LIMITS?.keywordRestr ==='Found'){
                setStatusLimit('failure')
            }
            else{
                setStatusLimit('')
            }
            setModalNote(res?.LIMITKWRREMARK !== null ? res?.LIMITKWRREMARK:t("transfers.limitTimeOutError"))
            limitMessage=res?.LIMITKWRREMARK !== null ? res?.LIMITKWRREMARK:t("transfers.limitTimeOutError")
            res?.LIMITS?.limitInfo?.split(';').map((row)=>{
                labelArray.push(row.split(':')[0])
                temp_array.push(row.split(':')[1])
            })

            set2ndTitle(labelArray[5])

            setSentCariCount(temp_array[6])
            setTypeTransfer(temp_array[1])
            setCommissionAmountModal(temp_array[3])
            setAmountModal(temp_array[2])
            setAmountTransfer(temp_array[7])
            setCariCount(temp_array[8])
            setCariTotalAmount(temp_array[9])
            setLimitTotalAmount(temp_array[10])
            setLoadingLimit(false)

        return res;

    }

    const cutOff = async () =>{
        const selected_level = levelCodeOptions.find(row => row.value == form.getFieldValue('BUDGETLEVELCODE'));
        setdisabledSign(true)

        var res = await cutOffService({
            PMTTYPECODE: "PT",
            PMTID: form.getFieldValue('PMTID'),
            CREATEDFROMTEMPL: getbyTemp,
            TEMPLATE: {
                TEMPLNAME: tempName
            },
            GETBYALIAS: getbyAlias,
            ALIAS: {
                ALIASTYPE: inputType,
                ALIASVALUE: inputType=== 'MOBILE'?'+994'+form.getFieldValue('alias_value'):form.getFieldValue('alias_value')
            },
            CUSTACC: custAcc,
            CUSTACCAVLBALANCE: fromBranch?.BALANCE,
            CUSTACCFORCOM: "",
            CUSTACCFORCOMCURR: "",
            BENEFNAME: form.getFieldValue('BENEFNAME'),
            BENEFACC: form.getFieldValue('BENEFACC'),
            BENEFTAXID: form.getFieldValue('BENEFTAXID'),
            BENEFBANKCODE: form.getFieldValue('BENEFBANKCODE'),
            BENEFBANKNAME: form.getFieldValue('BENEFBANKNAME'),
            BENEFBANKTAXID: bankTaxId,
            BENEFBANKCORACC: bankCorAcc,
            BENEFBANKSWIFT: bankSwift,
            PMTAMOUNT: checkAmountForRequest(form.getFieldValue('AMOUNT')),
            COMMAMOUNT: form.getFieldValue('CUSTACCFORCOM'),
            BUDGETCLASSCODE: form.getFieldValue('BUDGETCLASSCODE'),
            BUDGETCLASSCODENAME: "",
            BUDGETLEVELCODE:  form.getFieldValue('BUDGETLEVELCODE'),
            BUDGETLEVELCODENAME: selected_level ? selected_level.label : '',
            PMTDET: form.getFieldValue('PMTDET'),
            INFOTOBENEF: form.getFieldValue('INFOTOBENEF'),
            NOTE: form.getFieldValue("NOTE")

        },language)

            if(res.CUTOFFMSGSTAT === 'Success' && res.CUTOFF.isWorkingDay ==='Y' && res.CUTOFF.cutoffTime ==='Within'){
                setdisabledSign(false)
                setNextModalNote(res?.CUTOFFREMARK+'<br/>'+modalNote)
                messageCutOff = res?.CUTOFFREMARK+'<br/>'+limitMessage
            }else if(res.CUTOFFMSGSTAT === 'Success' && res.CUTOFF.isWorkingDay ==='Y' && res.CUTOFF.cutoffTime ==='Outof')
            {
                setdisabledSign(false)
                setAlertText(res?.CUTOFFREMARK)

                alertmessage =res?.CUTOFFREMARK

            }else if(res.CUTOFFMSGSTAT === 'Success' && res.CUTOFF.isWorkingDay ==='N' && res.CUTOFF.cutoffTime ==='Outof'){
                setdisabledSign(false)
                setAlertText(res?.CUTOFFREMARK)
                alertmessage =res?.CUTOFFREMARK

            }else if(res.CUTOFFMSGSTAT === 'Failure' ){
                setdisabledSign(true)
                setAlertText(res?.CUTOFFREMARK)
                alertmessage =res?.CUTOFFREMARK

            }else{
                setdisabledSign(true)
                setAlertText(t("transfers.cutOffError"))
                alertmessage =t("transfers.cutOffError")
            }
            setNextModalVisible(old_value => true);

    }

    const checkBenefAcc = async() =>{
        const selected_level = levelCodeOptions.find(row => row.value == form.getFieldValue('BUDGETLEVELCODE'));
        setdisabledSign(true)

        var resp = await benefBankAccCheck({
            PMTTYPECODE: "PT",
            PMTID: form.getFieldValue('PMTID'),
            CREATEDFROMTEMPL: getbyTemp,
            TEMPLATE: {
                TEMPLNAME: tempName
            },
            GETBYALIAS: getbyAlias,
            ALIAS: {
                ALIASTYPE: inputType,
                ALIASVALUE: inputType=== 'MOBILE'?'+994'+form.getFieldValue('alias_value'):form.getFieldValue('alias_value')
            },
            CUSTACC: custAcc,
            CUSTACCAVLBALANCE: fromBranch?.BALANCE,
            CUSTACCFORCOM:  form.getFieldValue('CUSTACCFORCOM') ==="---"? 0 : form.getFieldValue('CUSTACCFORCOM'),
            CUSTACCFORCOMCURR: currency,
            BENEFNAME: form.getFieldValue('BENEFNAME'),
            BENEFACC: form.getFieldValue('BENEFACC'),
            BENEFTAXID: form.getFieldValue('BENEFTAXID'),
            BENEFBANKCODE: form.getFieldValue('BENEFBANKCODE'),
            BENEFBANKNAME: form.getFieldValue('BENEFBANKNAME'),
            BENEFBANKTAXID: bankTaxId,
            BENEFBANKCORACC: bankCorAcc,
            BENEFBANKSWIFT: bankSwift,
            PMTAMOUNT: checkAmountForRequest(form.getFieldValue('AMOUNT')),
            COMMAMOUNT:  form.getFieldValue('CUSTACCFORCOM') ==="---"? 0 : form.getFieldValue('CUSTACCFORCOM'),
            BUDGETCLASSCODE: form.getFieldValue('BUDGETCLASSCODE'),
            BUDGETCLASSCODENAME: "",
            BUDGETLEVELCODE:  form.getFieldValue('BUDGETLEVELCODE'),
            BUDGETLEVELCODENAME: selected_level ? selected_level.label : '',
            PMTDET: form.getFieldValue('PMTDET'),
            INFOTOBENEF: form.getFieldValue('INFOTOBENEF'),
            NOTE: form.getFieldValue("NOTE")
        },language)
            if(resp.BENEFMSGSTAT === 'Failure' || resp.BENEFMSGSTAT === null){
                setdisabledSign(true)
                setNextModalVisible(old_value => false);
                setIsDisabled(true)
                setAccMessage(resp?.BENEFREMARK)
                setShowMessage(false)

            }else{
                await cutOff();
                setdisabledSign(false)
            }

    }

    const nextModalApi = async() =>{
        const budgetclass= form.getFieldValue('BUDGETCLASSCODE')
        const account_no = form.getFieldValue('BENEFACC')
        const bank_code = form.getFieldValue('BENEFBANKCODE')
        const bank_name = form.getFieldValue('BENEFBANKNAME')
        const amount = form.getFieldValue('AMOUNT')
        const teyinat = form.getFieldValue('PMTDET')

        if( budgetclass !==undefined && account_no!== undefined &&  amount !== undefined && bank_name !== undefined && bank_code !== undefined && amount !== undefined && teyinat !== undefined){

          return  await checkLimits()
        }



    }

    const newTransfer = async(RequestType : string, retry : boolean = false) =>{
        const selected_level = levelCodeOptions.find(row => row.value == form.getFieldValue('BUDGETLEVELCODE'));
     if(ibankRef !== "") {
            await   deleteFileById(ibankRef)
            await new Promise(res => setTimeout(res, 1000)); 
           }
        if (!retry) {
            const req =  {
                "trnRequestType": RequestType,
                "PMTTYPECODE": "PT",
                "PMTCUSTID": form.getFieldValue("PMTID"),
                "PMTID": form.getFieldValue("PMTID"),
                "CREATEDFROMTEMPL": getbyTemp,
                "TEMPLATE": {
                    "TEMPLNAME": tempName
                },
                "GETBYALIAS": getbyAlias,
                "ALIAS": {
                    "ALIASTYPE": inputType,
                    "ALIASVALUE": inputType === 'MOBILE' ? '+994' + form.getFieldValue('alias_value') : form.getFieldValue('alias_value'),
                },
                "CUSTACC": custAcc,
                "CUSTACCTYPE": " ",
                "CUSTACCAVLBALANCE": fromBranch?.BALANCE,
                "CUSTACCBRANCHCODE": '',
                "CUSTACCBRANCHCODECB": "",
                "CUSTACCFORCOM": "",
                "CUSTACCFORCOMCURR": "",
                "BENEFNAME": form.getFieldValue("BENEFNAME"),
                "BENEFACC": form.getFieldValue("BENEFACC"),
                "BENEFTAXID": form.getFieldValue("BENEFTAXID"),
                "BENEFBANKCODE": form.getFieldValue("BENEFBANKCODE"),
                "BENEFBANKNAME": form.getFieldValue("BENEFBANKNAME"),
                "BENEFBANKTAXID": bankTaxId,
                "BENEFBANKCORACC": bankCorAcc,
                "BENEFBANKSWIFT": bankSwift,
                "PMTAMOUNT": form.getFieldValue("AMOUNT"),
                "COMMAMOUNT": checkAmountForRequest(form.getFieldValue("CUSTACCFORCOM")),
                "BUDGETCLASSCODE": form.getFieldValue('BUDGETCLASSCODE'),
                "BUDGETCLASSCODENAME": "",
                "BUDGETLEVELCODE": form.getFieldValue('BUDGETLEVELCODE'),
                "BUDGETLEVELCODENAME": selected_level ? selected_level.label : '',
                "PMTDET": form.getFieldValue("PMTDET"),
                "INFOTOBENEF": form.getFieldValue("INFOTOBENEF"),
                "NOTE": form.getFieldValue("NOTE"),
                "CommCode": commCode,
                "ibankRef": ibankRef,
            }
            setRetryRequest(req);
            const data = IpsNewTransfer(req,language);
            return data;
        }else{
            if(retryRequest !== null)
                retryRequest['trnRequestType'] = RequestType;
            const data  = IpsNewTransfer(retryRequest,language);
            return data;
        }
    }

    return (
        <>
            <Row>
                <Col flex={'700px'} className="own-account">
                    <Card bordered={false}>
                        <Row justify='start' className="own-account__form">
                            <Form
                                labelCol={{ flex: '190px'}}
                                wrapperCol={{ flex: 1 }}
                                className='full'
                                onSubmit={(e) => e.preventDefault(e)}
                                onFinish={submitHandler}
                                id={'form'}
                                onValuesChange={updateParentComponentFormData}
                                form={form}
                                autoComplete="off"
                                scrollToFirstError={{
                                    behavior: 'smooth',
                                    block: 'center',
                                    inline: 'center',
                                }}
                            >

                                { !addOrEditPage &&<div className='flex ' >
                                    <InputField
                                        labelItem={t("salary.documentNo")}
                                        placeholder={t("salary.automatically")}
                                        name={'PMTID'}
                                        required={true}
                                        form={form}
                                        value={documentNo}
                                        message={true}
                                        maxLength={25}
                                        allowLatinNumber ={true}
                                    />

                                    <Button
                                        size={'large'}
                                        icon={<SaveIco />}
                                        className="blue-button transfer__button flex align_center justify_center create_tr_template_btn"
                                        onClick={e => setTemplatePopupVisible(true)}
                                    >
                                        {OWNACCOUNT.PATTERN}
                                    </Button>
                                </div>
                                }
                                <SelectField
                                    labelItem={t("transfers.fromAccount")}
                                    placeholder={t("accountStatement.chooseAccount")}
                                    options={fromSelectOptions}
                                    name={'CUSTACC'}
                                    value={custAcc}
                                    onChange={getSelectedFromBranch}
                                    required={true}
                                    form={form}
                                    notFoundContent={!loadingAccount ? t("newTransfer.noAccountCorrespondingCurrency")  : undefined}
                                    defaultValue={ibanNumber.iban}
                                />

                                <Divider plain orientation="left" className={'tab_divider_left'} >{t("newTransfer.beneficiaryBank")}</Divider>

                                <InputField
                                    labelItem={t("requisites.code")}
                                    placeholder="210005"
                                    value={'210005'}
                                    allowClear={true}
                                    className="not-required dark-input isReadOnly"
                                    readOnly={true}
                                    required={false}
                                    maxLength={6}
                                    isNumeric={true}
                                    onlyNumber={true}
                                    form={form}
                                    name={'BENEFBANKCODE'}
                                    staticValue={true}

                                />


                                <InputField
                                    labelItem={t("requisites.name")}
                                    placeholder={t("newTransfer.stateTreasuryAgencyDXA")}
                                    className="not-required dark-input isReadOnly"
                                    readOnly={true}
                                    required={false}
                                    value={t("newTransfer.stateTreasuryAgencyDXA")}
                                    form={form}
                                    onlyLetter={true}
                                    allowLatin={true}
                                    staticValue={true}
                                    name={'BENEFBANKNAME'}

                                />

                                <Divider plain orientation="left" className={'tab_divider_left'} >{t("common.beneficiary")}</Divider>

                                {/*<div  className={'flex align_center'}>*/}
                                {/*    <div className={'tab_form_label ant-form-item-label'} style={{marginTop : '-10px'}} >*/}
                                {/*        <label>{t("transfers.identifierANIPAY")}</label>*/}
                                {/*    </div>*/}

                                {/*    <Col flex="20px" className={'ant-form-item flex' }>*/}
                                {/*        <Checkbox*/}
                                {/*            onChange={updateAlias}*/}
                                {/*            disabled={!fromBranch?.ACCOUNT_NO}*/}
                                {/*            checked={aliasStatus}*/}

                                {/*        />*/}
                                {/*    </Col>*/}

                                {/*    <Col flex="130px" style={{marginLeft : 10, width :130}} >*/}
                                {/*        <SelectField*/}
                                {/*            labelCol={{ span: 7 }}*/}
                                {/*            labelItem=""*/}
                                {/*            placeholder={aliasStatus ? t("transfer.anipayType") : ' '}*/}
                                {/*            options={aliasList}*/}
                                {/*            disabled={!aliasStatus}*/}
                                {/*            onChange={chooseAlisa}*/}
                                {/*            value={selectedAlias}*/}
                                {/*            form={form}*/}
                                {/*            name={'alias_type'}*/}
                                {/*            className={'isDisabled'}*/}
                                {/*        />*/}
                                {/*    </Col>*/}

                                {/*    <Col flex="309px" style={{marginLeft : 10}}>*/}
                                {/*        <InputField*/}
                                {/*            labelCol={{ span: 7 }}*/}
                                {/*            labelItem=""*/}
                                {/*            placeholder={inputPlaceholder}*/}
                                {/*            disabled={!aliasStatus || (aliasStatus && !selectedAlias)}*/}
                                {/*            type={inputType}*/}
                                {/*            mask={inputMask}*/}
                                {/*            prefix={inputPrefix}*/}
                                {/*            value={inputValue}*/}
                                {/*            onChange={inputHandleChange}*/}
                                {/*            maxLength={inputMaxLength}*/}
                                {/*            form={form}*/}
                                {/*            name={'alias_value'}*/}
                                {/*            onBlur={checkAlias}*/}
                                {/*            showMessage={aliaserrorMessage!== ''??true}*/}
                                {/*            message={aliaserrorMessage}*/}
                                {/*            className={'isDisabled'}*/}
                                {/*        />*/}
                                {/*    </Col>*/}

                                {/*    {showLoading && <Button type={'ghost'}*/}
                                {/*    className={'transparent alias_loading'} icon={<SpinnerIco />} /> }*/}
                                {/*</div>*/}

                                {/*<Divider className='no_text' />*/}

                                <div className='flex'>
                                    {
                                    accMessage !== '' && <span className={' form_error_span'}>{accMessage}</span>
                                }
                                    <InputField
                                        labelItem={t("deposit.accountNumber")}
                                        placeholder={t("newTransfer.atLeast3Char")}
                                        allowClear={true}

                                        className={'not_show_required_props is_upper_case isDisabled'}
                                        name={'BENEFACC'}
                                        required={true}
                                        maxLength={'28'}
                                        form={form}
                                        onlyLetterAndNumber={true}
                                        readOnly={!fromBranch?.ACCOUNT_NO}
                                        onKeyUp={() => { updateBankCodes(false) }}
                                        autoComplete={true}
                                        options={bankCodes}
                                        filterRowClick={updateToBankCodeAndName}
                                        showMessage={message!== '' ?? true}
                                        message={message}
                                        upper={true}

                                    />

                                    <Col flex="40px" style={{ marginLeft: 10 }} >
                                        <Button
                                            size={'large'}
                                            icon={<SearchIco />}
                                            className="blue-button transfer__button flex align_center justify_center search_btn"
                                            onClick={() => { updateBankCodes(true) }}
                                            disabled={!fromBranch?.ACCOUNT_NO}
                                        >
                                        </Button>
                                    </Col>

                                    <Modal
                                        title={t("newTransfer.organizations")}
                                        closeIcon={<ModalCloseIco />}
                                        centered
                                        visible={codeModalVisible}
                                        onOk={() => setCodeModalVisible(false)}
                                        onCancel={() => setCodeModalVisible(false)}
                                        width={700}
                                        className={'manage_faster_menus swift_modal table_scroll_modal'}
                                        keyboard={false}
                                        focusTriggerAfterClose={false}
                                        footer={false}
                                    >
                                        <Form
                                            layout="vertical"
                                            onFinish={(e) => { }}
                                            autoComplete="off"
                                        >
                                            <table className={'table table-hover swift_table b_code_table'}>
                                                <thead>
                                                <tr>
                                                    <th>
                                                        <InputField
                                                            labelItem={t("deposit.accountNumber")}
                                                            placeholder={t("newTransfer.atLeast2Char")}
                                                            className={'hide_placeholder_on_focus input-border-modal'}
                                                            value={formFields?.BENEFACC}
                                                            name={'BENEFACC'}
                                                            form={form}
                                                            isNumeric={false}
                                                            maxLength={'6'}
                                                            onKeyUp={() => { updateBankCodes(true) }}
                                                            suffix={<Button onClick={() => { updateBankCodes(true) }} type={"ghost"} className={'transparent'} icon={<InputSearchIco />} />}
                                                        />
                                                    </th>

                                                    <th>
                                                        <InputField
                                                            labelItem={t("requisites.name")}
                                                            placeholder={t("transfers.atLeast3Char")}
                                                            className={'hide_placeholder_on_focus input-border-modal'}
                                                            allowLatin={true}
                                                            name={'BENEFBANKNAME_FILTER'}
                                                            form={form}
                                                            onKeyUp={() => { updateBankCodes(true) }}
                                                            suffix={<Button onClick={() => { updateBankCodes(true) }} type={"ghost"} className={'transparent'} icon={<InputSearchIco />} />}
                                                        />
                                                    </th>
                                                </tr>
                                                </thead>

                                                <tbody>
                                                {
                                                    bankCodes?.map(row => {
                                                        return (
                                                            <tr onClick={() => { updateToBankCodeAndName(row) }} >
                                                                <td>{row.code}</td>
                                                                <td>{row.name}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </Form>


                                    </Modal>
                                </div>

                                <InputField
                                    labelItem={t("requisites.name")}
                                    placeholder={t("newTransfer.organizationName")}
                                    required={false}
                                    name={'BENEFNAME'}
                                    className='not-required dark-input isReadOnly'
                                    readOnly={true}
                                    maxLength={140}
                                    onlyLetter={true}
                                    form={form}
                                />

                                <InputField
                                    labelItem={t("requisites.taxID")}
                                    placeholder=""
                                    required={false}
                                    className='not-required dark-input isReadOnly'
                                    // readOnly={true}
                                    disabled={aliasStatus}
                                    isNumeric={true}
                                    onlyNumber={true}
                                    maxLength={'10'}
                                    form={form}
                                    name={'BENEFTAXID'}
                                />

                                <Divider plain orientation="left" className={'tab_divider_left'} >{t("newTransfer.budgetCodes")}</Divider>

                                <div className='flex'>
                                    <InputField
                                        labelItem={t("newTransfer.budgetClassificationCodes")}
                                        placeholder={t("newTransfer.atLeast2Char")}
                                        allowClear={true}
                                        className="not_show_required_props isReadOnly ant-input-border"
                                        isNumeric={true}
                                        onlyNumber={true}
                                        name={'BUDGETCLASSCODE'}
                                        value={formFields?.BUDGETCLASSCODE}
                                        required={true}
                                        form={form}
                                        showMessage={showMessage}
                                        message={t("transfers.budgetCodeError")}
                                        readOnly={!fromBranch?.ACCOUNT_NO}
                                        onKeyUp={() => { updateClassCodes(false) }}
                                        autoComplete={true}
                                        options={classCodes}
                                        filterRowClick={updateToClassCodeAndName}
                                    />
                                    <Col flex="40px" style={{ marginLeft: 10 }} >
                                        <Button
                                            size={'large'}
                                            icon={<SearchIco />}
                                            className="blue-button transfer__button flex align_center justify_center search_btn"
                                            onClick={() => { updateClassCodes(true) }}
                                            disabled={!fromBranch?.ACCOUNT_NO}
                                        >
                                        </Button>
                                    </Col>

                                    <Modal
                                        title={t("newTransfer.budgetClassificationCode")}
                                        closeIcon={<ModalCloseIco />}
                                        centered
                                        visible={classModalVisible}
                                        onOk={() => setClassModalVisible(false)}
                                        onCancel={() => setClassModalVisible(false)}
                                        width={700}
                                        className={'manage_faster_menus swift_modal table_scroll_modal'}
                                        keyboard={false}
                                        focusTriggerAfterClose={false}
                                        footer={false}
                                    >
                                        <Form
                                            layout="vertical"
                                            onFinish={(e) => { }}
                                            autoComplete="off"
                                        >
                                            <table className={'table table-hover swift_table b_code_table'}>
                                                <thead>
                                                <tr>
                                                    <th>
                                                        <InputField
                                                            labelItem={t("requisites.code")}
                                                            placeholder={t("newTransfer.atLeast2Char")}
                                                            className={'hide_placeholder_on_focus input-border-modal'}
                                                            value={formFields?.BUDGETCLASSCODE}
                                                            name={'BUDGETCLASSCODE'}
                                                            form={form}
                                                            isNumeric={true}
                                                            onlyNumber={true}
                                                            maxLength={'6'}
                                                            onKeyUp={() => { updateClassCodes(true) }}
                                                            suffix={<Button onClick={() => { updateClassCodes(true) }} type={"ghost"} className={'transparent'} icon={<InputSearchIco />} />}
                                                        />
                                                    </th>

                                                    <th>
                                                        <InputField
                                                            labelItem={t("transfers.description")}
                                                            placeholder={t("transfers.atLeast3Char")}
                                                            className={'hide_placeholder_on_focus input-border-modal'}
                                                            allowLatin={true}
                                                            name={'BUDGETCLASSNAME_FILTER'}
                                                            form={form}
                                                            onKeyUp={() => { updateClassCodes(true) }}
                                                            suffix={<Button onClick={() => { updateClassCodes(true) }} type={"ghost"} className={'transparent'} icon={<InputSearchIco />} />}
                                                        />
                                                    </th>
                                                </tr>
                                                </thead>

                                                <tbody>
                                                {
                                                    classCodes?.map(row => {
                                                        return (
                                                            <tr onClick={() => { updateToClassCodeAndName(row) }} >
                                                                <td>{row.code}</td>
                                                                <td>{row.name}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </Form>


                                    </Modal>

                                </div>

                                <SelectField
                                    labelItem={t("newTransfer.budgetLevelCode")}
                                    placeholder={t("transfers.select")}
                                    options={levelCodeOptions}
                                    name={'BUDGETLEVELCODE'}
                                    required={true}
                                    form={form}
                                    showSearch={true}
                                    disabled={!fromBranch?.ACCOUNT_NO}
                                    className={'isDisabled'}
                                />

                                <div className={'flex relative'}  >
                                    <AmountField
                                        labelItem={t("common.amount")}
                                        placeholder=""
                                        suffix={'AZN'}
                                        name={'AMOUNT'}
                                        className={'amount_and_commission_col amount_input amount_input_width_btn isDisabled'}
                                        required={true}
                                        form={form}
                                        disabled={!fromBranch?.ACCOUNT_NO}
                                        // onBlur={calculateCommission}
                                        onChange={(e) => debouncedCommission(e.target.value)}
                                    />

                                    <Col className={'commission_col mobile-select'}>
                                        <InputField
                                            labelCol={2}
                                            labelItem={t("home.commission")}
                                            placeholder=""
                                            className="dark-input commission_input commission_input_with_btn isReadOnly"
                                            readOnly={true}
                                            suffix="AZN"
                                            customClass={'custom_anipay_spin'}
                                            name={'CUSTACCFORCOM'}
                                            value={commissionAmount}
                                            hasLoading={commissionLoading}
                                            form={form}
                                        />
                                    </Col>

                                    <Col flex={'72px'} style={{marginLeft : 10}} >
                                        <Button
                                            size={"large"}
                                            className={'blue-button btn flex align_center justify_center'}
                                            disabled={!fromBranch?.ACCOUNT_NO}
                                            onClick={()=>{checkLimits();setlimitModal(true)}}
                                            loading={loadinglimit}

                                        >{t("businessCards.limits")}</Button>
                                    </Col>
                                    {
                                        limitModal && !loadinglimit &&
                                        <LimitsModal
                                            visible={limitModal}
                                            onOk={()=>setlimitModal(false)}
                                            onCancel={()=>setlimitModal(false)}
                                            data={modalDataLimit}
                                        />

                                    }
                                    <div className={'flex align_center limit_buttons'} >
                                        {statusLimit !== '' ?

                                            statusLimit === 'success' ?
                                                <Button type={"ghost"} className={'transparent flex align_center justify_center limit_success_ico'} icon={<CheckGreenIco />} /> :
                                                <Button type={"ghost"} className={'transparent flex align_center justify_center limit_cancel_ico'} icon={<CancelRedIco />} /> : <></>

                                        }


                                    </div>
                                </div>

                                <TextAreaField
                                    visible={true}
                                    labelItem={t("accountStatement.paymentDetails")}
                                    placeholder=""
                                    showCount={true}
                                    name={'PMTDET'}
                                    required={true}
                                    maxLength={'210'}
                                    allowLatin={true}
                                    form={form}
                                    // allowDestination={true}
                                    readOnly={!fromBranch?.ACCOUNT_NO}
                                    className={'isDisabled'}
                                />

                                <TextAreaField
                                    visible={true}
                                    labelItem={t("transfers.infoForBeneficiary")}
                                    placeholder=""
                                    name={'INFOTOBENEF'}
                                    showCount={true}
                                    maxLength={'560'}
                                    className={'no_required isDisabled'}
                                    allowLatin={true}
                                    form={form}
                                    readOnly={!fromBranch?.ACCOUNT_NO}
                                />

                                <div className={'flex'}>
                                    <Col flex={1}>
                                        <TextAreaField
                                            visible={visible}
                                            className='not-required isDisabled'
                                            labelItem={t("newTransfer.note")}
                                            placeholder={t("newTransfer.notTransferableToBank")}
                                            showCount={true}
                                            maxLength={'180'}
                                            name={'NOTE'}
                                            form={form}
                                            exchangeNote={true}
                                            // allowAllSymboll={true}
                                            readOnly={!fromBranch?.ACCOUNT_NO}
                                        />
                                    </Col>
                                    <Button
                                        className="icon-button add-remove-btn"
                                        icon={visible ? <MinusSmallIco /> : <PlusSmallIco />}
                                        onClick={() => setVisible(!visible)}
                                    />
                                </div>

                                <FileUpload
                                    className='file-upload isDisabled'
                                    labelItem={t("newTransfer.attachPDF")}
                                    form={form}
                                    fileLimit={10}
                                    checkSize={true}
                                    name={'pdf_files'}
                                    onChange={getFileList}
                                    editFileList={fileList}
                                    tempFileList={fileUp}
                                    accept="application/pdf"
                                    multiple={false}
                                    required={false}
                                    removeFile={removeFile}
                                    disabled={!fromBranch?.ACCOUNT_NO}
                                />

                                { !addOrEditPage && <div  className='flex button_row' >
                                    <Button
                                        size={'large'}
                                        icon={<SaveBlueIco />}
                                        className="light-button btn save_btn flex align_center justify_center"
                                        htmlType={"button"}
                                        onClick={openSaveAsTemplateModal}
                                    >
                                        {OWNACCOUNT.SAVE}
                                    </Button>

                                    <div className={'flex flex_wrap'}>
                                        <Button

                                            size={'large'}
                                            icon={<RefreshIco />}
                                            className="light-button refresh_btn btn flex align_center justify_center"
                                            onClick={(e) => { resetFormFields(); resetForm(form); form.setFieldsValue({'BUDGETLEVELCODE': undefined}) }}
                                        >
                                            {t(OWNACCOUNT.REFRESH)}
                                        </Button>

                                        <Button
                                            size={'large'}
                                            htmlType="submit"
                                            className="blue-button next_btn btn flex align_center justify_center"
                                            disabled={isDisabled || !form.getFieldValue('BENEFNAME')}
                                            // onClick={nextModalApi}
                                        >
                                            {OWNACCOUNT.NEXT}
                                        </Button>


                                    </div>

                                </div>
                                }
                            </Form>
                        </Row>
                    </Card>
                </Col>
            </Row>

            <NextModal
                errorIcon={<EroorIco />}
                callBackApi={newTransfer}
                visible={nextModalVisible}
                onCloseSuccessModal={onCloseSuccessModal}
                onClose= {() => {setNextModalVisible(false);setRetryRequest(null); }}
                data={modalData}
                anipay={true}
                className={'no_footer_line'}
                disabled={disabledSign}
                repeatPdfList={fileList}
                currentForm={form}
                transfer={true}
                editTransfer={ibankRef !== undefined && ibankRef !== '' && ibankRef !== null}

            />

            <TemplatePopup
                visible={templatePopupVisible}
                onClose={setTemplatePopupVisible}
                trnType={'IPS_BDG'}
                currentForm={form}
                // setFileList = {setFileUp}
                updateAfterTemplate={updateDocumentNumberAndCommission}
            />

            <SaveAsTemplate
                visible={saveAsTemplatePopupVisible}
                onClose={setSaveAsTemplatePopupVisible}
                trnType={'IPS_BDG'}
                currentForm={form}
            />
            {
                loadingData ? <FullScreenLoading /> : <></>
            }
        </>
    )
}

const mapDispatchToProps = {setIbanNumber}

const mapStateToProps = (state: any,ownProps:any) => ({
    ownProps: ownProps,
    ibanNumber: (state.accountsStatement && state.accountsStatement.ibanNumber) ? state.accountsStatement.ibanNumber : {}
});

export default connect(mapStateToProps, mapDispatchToProps)(Dxa)
